import { observer } from 'mobx-react-lite'
import { useGetStep } from 'shared/hooks'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'
import { useRcsProgressTitle } from 'pages/settings/pages/rcsV2/hooks/useRcsProgressTitle'
import { type RcsWizardSteps } from 'pages/settings/pages/rcsV2/route/type'

export const RcsWizardLayout = observer(() => {
  const {
    closeWizard,
    navigationStore: { allStepsLength, decreaseStep, getSettingsStep },
  } = useRcsWizardContext()
  const settingsStep = useGetStep<RcsWizardSteps>(getSettingsStep)
  const progressTitle = useRcsProgressTitle()

  return (
    <StepsCommonLayout
      title='RCS'
      progressTitle={progressTitle}
      totalSteps={allStepsLength}
      settingsStep={settingsStep}
      closeSetting={closeWizard}
      decreaseStep={decreaseStep}
    />
  )
})
